import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NotFound from "@containers/NotFound";
import Login from "@containers/Login";
import Dashboard from "@containers/Dashboard";
import Layout from "@containers/Layout";

const AppRoutes = () => (
  <BrowserRouter>
    <Layout>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path={"/"} element={<Login />} exact={true} />
        <Route path={"/dashboard"} element={<Dashboard />} exact={true} />
      </Routes>
    </Layout>
  </BrowserRouter>
);

export default AppRoutes;
